import { render, staticRenderFns } from "./A3Info.vue?vue&type=template&id=b4a087f6&"
import script from "./A3Info.vue?vue&type=script&lang=ts&"
export * from "./A3Info.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports